<template>
  <div class="row" v-if="$route.params.activationToken">
    <div class="col-12 col-lg-6 offset-lg-3 d-flex align-items-center">
      <div class="card card-success w-100">
        <div class="card-body text-center px-3 px-md-1">
          <small v-if="error">
            {{ $t("invalid_token") }}
          </small>
          <small v-else>
            {{ $t("login_in_progress") }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  mounted() {
    if (this.$route.params.loginToken) {
      this.$store
        .dispatch("onboarding/loginWithToken", {
          token: this.$route.params.loginToken
        })
        .then()
        .catch(() => {
          this.error = true;
        });
    }
  },
  data() {
    return {
      error: null
    };
  }
};
</script>
